// @flow
import React from 'react';
import { InputGroup, Input, InputGroupAddon } from 'reactstrap';

type Props = {
  onChange: Function,
};

const ENTER_KEY_CODE = 13;

const SearchBar = ({ onChange }: Props) => {
  let inputRef = React.createRef();

  const handleSearch = () => {
    onChange(inputRef.value);
  };

  const handleEnterPress = e => {
    if (e.keyCode === ENTER_KEY_CODE) {
      onChange(inputRef.value);
    }
  };

  return (
    <InputGroup>
      <Input
        type="text"
        placeholder="Search By Name , Email, User Id"
        innerRef={node => (inputRef = node)}
        onKeyDown={handleEnterPress}
      />
      <InputGroupAddon addonType="append">
        <span className="input-group-text" onClick={handleSearch}>
          <i className="icon icon-hg-search" />
        </span>
      </InputGroupAddon>
    </InputGroup>
  );
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/SearchBar.jsx